export default "__VITE_ASSET__DkVB_$KS__"